import { createContext, useContext, useState } from "react";

interface RequestIntervalContextProps {
  requestIntervalIndex: number;
  accountStatusMutationFetchingPaused: boolean;
  setRequestIntervalIndex: React.Dispatch<React.SetStateAction<number>>;
  resetRequestIntervalIndex: () => void;
  pauseFetchingAccountStatus: () => void;
  resumeFetchingAccountStatus: () => void;
}

const RequestIntervalContext = createContext<
  RequestIntervalContextProps | undefined
>(undefined);

export const useRequestIntervalContext = () => {
  const context = useContext(RequestIntervalContext);
  if (!context) {
    throw new Error(
      "useRequestIntervalContext must be used within a RequestIntervalContextProvider"
    );
  }
  return context;
};

export const RequestIntervalContextProvider: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  const [requestIntervalIndex, setRequestIntervalIndex] = useState<number>(0);

  const [
    accountStatusMutationFetchingPaused,
    setAccountStatusMutationFetchingPaused,
  ] = useState(false);

  const resetRequestIntervalIndex = () => setRequestIntervalIndex(0);
  const pauseFetchingAccountStatus = () =>
    setAccountStatusMutationFetchingPaused(true);
  const resumeFetchingAccountStatus = () =>
    setAccountStatusMutationFetchingPaused(false);

  return (
    <RequestIntervalContext.Provider
      value={{
        requestIntervalIndex,
        accountStatusMutationFetchingPaused,
        setRequestIntervalIndex,
        resetRequestIntervalIndex,
        pauseFetchingAccountStatus,
        resumeFetchingAccountStatus,
      }}
    >
      {children}
    </RequestIntervalContext.Provider>
  );
};
